import React, { useEffect, useRef } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import ChatInput from './chatinput';
import PersonIcon from '@mui/icons-material/Person';
import useFetchChats from '../hooks/useFetchChats';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import GSVideo from '../../../../components/getstream/GSVideo.component';

const Chats = () => {
    const userInfo = useSelector(state => state.auth.user);
    const { chats } = useFetchChats();
    const chatWindowRef = useRef();

    useEffect(() => {
      const scrollToBottom = () => {
        // NOTE: Its a hack as of now, but we need some standard code
        setTimeout(() => {
            chatWindowRef?.current?.scrollTo({
                top: chatWindowRef.current.scrollHeight,
                behavior: 'smooth' // This creates a smooth scrolling effect
            });
        }, 50);
      };

      scrollToBottom();
      document.addEventListener(CUSTOM_EVENTS.SCROLL_CHAT_WINDOW, scrollToBottom);
      return () => {
        document.removeEventListener(CUSTOM_EVENTS.SCROLL_CHAT_WINDOW, scrollToBottom);
      };
    }, []);

    const getProfilePic = (chat) => {
        const {senderId, doctorId, userId} = chat;
        if (senderId === doctorId && chat?.doctor?.doctorprofile?.profilePic) {
            return <Avatar className='logo' alt="profile_pic" src={chat.doctor.doctorprofile.profilePic} />;
        }

        if (senderId === userId && chat?.patient?.patientprofile?.profilePic) {
            return <Avatar className='logo' alt="profile_pic" src={chat.patient.patientprofile.profilePic} />;
        }

        // Its temp as we are updating the stating instantly when user enters the message in the chat (only for frontend)
        if (chat?.tempPic) {
            return <Avatar className='logo' alt="profile_pic" src={chat.tempPic} />;
        }

        return (
            <Avatar className='logo'>
                <PersonIcon />
            </Avatar>
        );
    };

    const chatsUI = chats.map(chat => {
        const chatClass = `message ${chat.senderId === userInfo.userId ? 'right' : 'left'}`;
        return (
            <li key={chat.id} className={chatClass}>
                {getProfilePic(chat)}
                <p>{chat.message}</p>
            </li>
        );
    });

    const emptyConversationsUI = (
        <div className='empty-conversation-container'>
             <Box>
                <Typography variant="h6" gutterBottom>
                    No Conversations
                </Typography>
                <Typography variant="caption" display="block" gutterBottom>
                    Please, send message to start conversation
                </Typography>
             </Box>
        </div>
    );

    const chatContent = () => {
        if (chats.length < 1) {
            return emptyConversationsUI;
        }

        return chatsUI;
    };

    return (
        <ul ref={chatWindowRef} className="chat">
            {chatContent()}
        </ul>
    );
};

const AppointmentChat = () => {
    return (
        <Box className="appointment-chat-container">
            <div className="uploaded-docs-vid-call">
                    <GSVideo />
            </div>
            <div className="chat-container">
                <Chats />
                <ChatInput />
            </div>
        </Box>
    );
};

export default AppointmentChat;